import React from "react";

type Base64ImageProps = {
  base64: string;
  mimeType?: string; // default "image/jpeg"
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
};

const Base64Image: React.FC<Base64ImageProps> = ({
  base64,
  mimeType = "image/jpeg",
  alt = "Base64 image",
  className,
  style,
}) => {
  const src = `data:${mimeType};base64,${base64}`;
  return <img src={src} alt={alt} className={className} style={style} />;
};

export default Base64Image;
